module.exports = __webpack_public_path__ + "img/netlify-icon.7a07528b.svg";